import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { put } from 'app/shared/utils/fetchr';
import { sendErrorToast, sendSuccessToast } from 'app/shared/toasts/actions';
import { RISK_MODEL_QUERY_KEYS } from 'app/modules/riskRatings/queries/keys';
import { RISK_SCORE_QUERY_KEYS } from 'app/modules/riskScore/queries/keys';
import { selectCrrRiskScoreFlatteningEnabled } from 'app/shared/featureFlags/selectors';

interface ApplyRiskScoreOverridePayload {
  score: number;
  comment: string;
  expires_at?: string;
}

export const useApplyRiskScoreOverride = (entityExternalId: string) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const isFlatteningEnabled = useSelector(selectCrrRiskScoreFlatteningEnabled);
  return useMutation({
    mutationFn: (payload: ApplyRiskScoreOverridePayload) => {
      const apiVersion = isFlatteningEnabled ? 'v2' : 'v1';
      return put(
        `/${apiVersion}/risk/entities/${entityExternalId}/override`,
        payload,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: RISK_SCORE_QUERY_KEYS.getEntityRiskScore(entityExternalId),
      });
      queryClient.invalidateQueries({
        queryKey:
          RISK_MODEL_QUERY_KEYS.fetchOverriddenEntitiesByRiskModelBase(),
      });
      dispatch(sendSuccessToast('Successfully applied risk score override.'));
    },
    onError: () =>
      dispatch(
        sendErrorToast(
          'Failed to apply risk score override. Please try again.',
        ),
      ),
  });
};
